import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Components
// import Phone from '../../../shared/components/Phone'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

// Elements
import { ElementIcons } from '../../../shared/elements/icons'
import Actions from '../../../shared/elements/actions'
import Button from '../../../shared/elements/button'
import Col from '../../../shared/elements/col'
import Icon from '../../../shared/elements/icon'
import Label from '../../../shared/elements/label'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Panel from '../../../shared/elements/panel'
import Row from '../../../shared/elements/row'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import Textarea from '../../../shared/elements/textarea'

// import styles
import './view.scss'

// Actions
import { CreateSavePartner, getPartner } from '../../../actions/workProvider'
import { getAgreementConstraints } from '../../../actions/agreementConstraint'

// Utils
import { translation } from '../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      partner: {},
      constraints: [],
      confirmDelete: {
        open: false
      }
    }
  }

  componentDidMount () {
    this.getPartner(this.props)
    this.getAgreementConstraints(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this.getPartner(nextProps)
    this.getAgreementConstraints(nextProps)
  }

  getPartner (props) {
    if (typeof props.item.WorkProviderId !== 'undefined') {
      props.getPartner(props.item.WorkProviderId).then((res) => {
        this.setState({
          type: 'edit',
          partner: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  getAgreementConstraints (props) {
    if (typeof props.item.WorkProviderId !== 'undefined') {
      props.getAgreementConstraints(props.item.WorkProviderId).then((res) => {
        this.setState({
          type: 'edit',
          constraints: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      partner: {
        Active: false,
        Comment: '',
        DebitNr: '',
        IsDeleted: false,
        Name: ''
      },
      constraints: [],
      confirmDelete: {
        open: false
      }
    })
  }

  saveAddPartners () {
    return this.props.CreateSavePartner(this.state.partner).then((res) => {
      this.props.onSave(res.data, this.state.type)
    }, () => {
      // Toastr
      window.toastr.error(translation('1733'), translation('216'))
    })
  }

  onRadioChange (e) {
    // console.log(e.target)
    let value = e.target.value
    let name = e.target.name
    this.setState({
      shop: {
        ...this.state.shop,
        [name]: value
      }
    }, this.saveAddShop
    )
  }

  renderPartner () {
    let { partner } = this.state
    if (Object.keys(partner).length === 0) return null

    const ActiveChecked = (type, active) => {
      if (active === type) {
        return (
          true
        )
      }
    }

    // On change
    const onChange = (e) => {
      let value = e.target.value
      let name = e.target.name
      if (name === 'PhoneNumber') name = 'Phone'
      if (name === 'PhoneCode') {
        value = {
          Id: value
        }
      }
      if (name === 'Active') {
        value = value === 'true'
      }
      this.setState({
        partner: {
          ...this.state.partner,
          [name]: value
        }
      }, () => {
        if (name === 'PhoneCode' && this.state.type === 'edit') {
          this.saveAddPartners()
        }
        if (name === 'Active') {
          onBlur()
        }
      })
    }
    // On blur
    const onBlur = (e) => {
      if (this.state.type === 'edit') {
        this.saveAddPartners()
      }
    }

    const onDelete = () => {
      this.setState({
        confirmDelete: {
          open: true
        }
      })
    }
    let isCreate = true // disable delete for now. // this.state.type === 'create'
    return (
      <Panel title={translation('1878')}>
        <Text name='Name' value={partner.Name} onChange={onChange} onBlur={onBlur} labelText={translation('30')} />
        <LabelWrapper labelText={translation('149')}>
          <Textarea name='Comment' value={partner.Comment} onChange={onChange} onBlur={onBlur} />
        </LabelWrapper>
        <Switch name='Active' value='true' checked={ActiveChecked(true, partner.Active) || false} onChange={onChange} labelText={translation('295')} />
        {!isCreate && <Button onClick={onDelete} labelText={translation('786')} />}
      </Panel>
    )
  }

  renderContacts () {
    if (this.state.type === 'create') return null
    let { partner } = this.state

    const renderContact = (val, key) => {
      return (
        <Label key={key}><Link to={'/partners/' + partner.WorkProviderId + '/contacts/' + val.UserId}>{val.Name}</Link></Label>
      )
    }

    return (
      <Panel title={translation('13460')}>
        <Actions>
          <Link to={'/partners/' + partner.WorkProviderId + '/contacts'}>
            <div className='hint--left' aria-label={translation('12295')}>
              <Icon icon={ElementIcons.Edit} size='t' />
            </div>
          </Link>
        </Actions>

        {partner.WorkProviderContacts !== undefined && partner.WorkProviderContacts !== null ? partner.WorkProviderContacts.map(renderContact) : undefined}
      </Panel>
    )
  }

  renderAgreements () {
    if (this.state.type === 'create') return null
    let { partner } = this.state
    let constraints = this.state.constraints
    let grouping = []
    for (let i = 0; i < constraints.length; i++) {
      let group = grouping.find((val, idx) => { return val.customerGroupName === constraints[i].CustomerGroupName })
      if (group === undefined) {
        group = {
          customerGroupName: constraints[i].CustomerGroupName,
          constraints: []
        }
        grouping.push(group)
      }
      group.constraints.push(constraints[i])
    }

    const renderGroup = (group, key) => {
      const renderConstraint = (val, key) => {
        let name = val.Name
        if (val.Brand !== undefined && val.Brand !== null) {
          name += ' (' + val.Brand + ')'
        }
        return (
          <Label key={val.AgreementConstraintId}>
            <Link to={'/partners/' + partner.WorkProviderId + '/constraints/' + val.AgreementConstraintId}>
              {name}
            </Link>
          </Label>
        )
      }

      let groupName = group.customerGroupName
      if (groupName === null) groupName = '(' + translation('12268') + ')'
      return (
        <div key={'group_' + key}>
          <h3>{groupName}</h3>
          {group.constraints.map(renderConstraint)}
        </div>
      )
    }

    return (
      <Panel title={translation('12284')}>
        <Actions>
          <Link to={'/partners/' + partner.WorkProviderId + '/constraints'}>
            <div className='hint--left' aria-label={translation('12294')}>
              <Icon icon={ElementIcons.Edit} size='t' />
            </div>
          </Link>
        </Actions>

        {grouping.map(renderGroup)}
      </Panel>
    )
  }

  render () {
    return (
      <Row>
        <Col>
          {this.renderPartner()}
          {this.renderContacts()}
        </Col>
        <Col>
          {this.renderAgreements()}
        </Col>
        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
            <Confirm confirm={this.onConfirmDelete.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
          </Portal>
        )}
      </Row>
    )
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }
  onConfirmDelete () {
    this.onPortalClose('confirmDelete')
    //  let price = { ...this.state.price }
    //  price.IsDeleted = true
    //  this.updatePrices(price).then(() => {
    //    this.props.onShouldUpdate()
    //  })
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode
  }
}

export default connect(mapStateToProps, {
  CreateSavePartner,
  getPartner,
  getAgreementConstraints
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/Partners/View/index.js